import { render, staticRenderFns } from "./EmployeeAnnualLeave.vue?vue&type=template&id=7806f56e&"
import script from "./EmployeeAnnualLeave.vue?vue&type=script&lang=js&"
export * from "./EmployeeAnnualLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports